import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import Config from "./Config";
import { useAuthHandling } from './useAuthhandling';
import SimpleBar from "simplebar-react";
import socket from "../../src/socket";
import { clearAuthStorage } from "./authStorage";

function Navbar() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const handle = async (e) => {
    clearAuthStorage();
    navigate("/");
  };
  const [visible, setVisible] = useState(true);
  const[notification,setNotification]=useState([]);
  const[countn,setCountn]=useState(0);
  const[toggle,setToggle]=useState(false);
  const[socketmessage,setSocketmessage]=useState([]);

  const getnotification = async (e) => {
     
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/notification-list`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data1 = await res.json();
      const data = data1.data;
      if(data.length>0){
        let count = 0;
        for (let i = 0; i < data.length; i++) {
          if (!data[i].read) {
            count++;
          }
        }
       
         setCountn(count);
         setNotification(data);
        // updatenotificationcount(count);
      }
    } 
    else if(res.status===401){
      handleUnauthorized();
      getnotification();
      // getnotification();
    }
    else {
      console.log("Something went wrong!");

    }
  

};
  useEffect(() => {
   
    getnotification();
    },[])


      const hadletoggle = async (e) => {
      setToggle(!toggle);
       const res = await fetch(
          `${Config.apiurl}/api/v1/crm/read-notification`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        );
        if (res.status === 200 ) {
          getnotification();
           
        } 
        else if(res.status===401){
          handleUnauthorized();
          hadletoggle();
          // getnotification();
        }
        else {
          console.log("Something went wrong!");
    
        }
    }
    useEffect(() => {
      socket.connect();
     socket.on("adminNotificationObj", ( message ) => {
       setSocketmessage(message);
       let count=countn+message.length;
      setCountn(count);
     }); 
    
     return () => {
       // Disconnect the socket when the component unmounts
       socket.disconnect();
     }; 
   }, []);
    
   const notificationRef = useRef(null);

 
 
   const handleClickOutside = (event) => {
     if (notificationRef.current && !notificationRef.current.contains(event.target)) {
       // Clicked outside the notification bar
       setToggle(false);
     }
   };
 
   useEffect(() => {
     document.addEventListener('mousedown', handleClickOutside);
 
     return () => {
       document.removeEventListener('mousedown', handleClickOutside);
     };
   }, []);


   useEffect(() => {
    window.scrollTo(0, 0);
   
  }, []);
  return (
    <>
      <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a
            className="navbar-brand brand-logo me-5"
            href="/dashboard"
            style={{ textDecoration: "none" }}
          >
            <h3 className="logostyle">
              HOME
              <span style={{ fontFamily: "Alba", fontSize: "24pt" }}>.</span>
            </h3>
            {/* </Link> */}
            {/* </div> */}
          </a>
          <a
            className="navbar-brand brand-logo-mini"
            href="/dashboard"
            style={{ textDecoration: "none" }}
          >
            <div className="nav-logo">
              <Link to="/dashboard" style={{ textDecoration: "none" }}>
                <h3 className="logostyle">
                  HOME
                  <span style={{ fontFamily: "Alba", fontSize: "24pt" }}>
                    .
                  </span>
                </h3>
              </Link>
            </div>
          </a>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
          

          <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item"><Link className="notfi_link" to="#" onClick={hadletoggle}>Message icon
           
            </Link></li>
            <li className="nav-item"><Link className="notfi_link" to="#" onClick={hadletoggle}><img className='notif_icon' src="/img/bellicon.png" />
             {countn===0?
            
            "":<span className="badge_new">{countn===0?'':(countn)}</span>
             }
            </Link></li>
            
            {toggle===true?
            <div className="notification_bar" ref={notificationRef}>
          {notification.length>0?
          <SimpleBar style={{ height: "320px" }}>
             <div className="dropdown-header mt-2">
              <h6 className="text-overflow text-muted mb-1 text-uppercase">
                Notification
               </h6>
            </div> 
                {socketmessage.length>0?
                  socketmessage.map((msg,ind)=>{
                    return(
                  
                      <Link to="#" className="dropdown-item notify-item " key={ind} >
                         <i className="fa fa-genderless align-middle fs-18 text-muted me-2"></i>
                         {/* <span dangerouslySetInnerHTML={{ __html: msg.message }}></span> */}
                         {/* <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(msg.message) }}></span> */}
                         <span>{msg.message}</span>
                     </Link>
                    
                     )
                  }):""}
                {notification.map((not,i)=>{
                  return(
                  
                   <Link to="#" className="dropdown-item notify-item " key={i} >
                      <i className="fa fa-genderless align-middle fs-18 text-muted me-2"></i>
                      {/* <span dangerouslySetInnerHTML={{ __html: not.message }}></span> */}
                      <span dangerouslySetInnerHTML={{ __html: not.message }}></span>
                      {/* <span>{not.message}</span> */}
                  </Link>
                 
                  )
                })
                }
          </SimpleBar>
          :
          <SimpleBar style={{ height: "50px" }}>
          <div className="dropdown-header mt-2">
           <h6 className="text-overflow text-muted mb-1 text-uppercase text-center">
           No Notification Found
            </h6>
         </div> 
         
            
       </SimpleBar>
      }

             </div>
             :""}
            <li className="nav-item nav-profile dropdown">
              <a
                className="nav-link"
                href="/dashboard"
                data-bs-toggle="dropdown"
                id="profileDropdown"
              >
                <img
                  src="../img/home.png"
                  alt="profile"
                  style={{ backgroundColor: "white" }}
                />
              </a>
              <div
                className="dropdown-menu dropdown-menu-right navbar-dropdown"
                aria-labelledby="profileDropdown"
              >
                <a className="dropdown-item logout" onClick={handle}>
                  <i className="ti-power-off text-primary">
                    <i className="fa-solid fa-power-off" />
                  </i>
                  Logout
                </a>
                <a className="dropdown-item logout" href="/addadmin">
                  <i className="ti-power-off text-primary">
                    <i class="fa fa-user-plus"></i>
                  </i>
                  Add admin user
                </a>
              </div>
            </li>
          </ul>
          {/* <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
          >
            <span className="ti-layout-grid2">
              <i className="fa-solid fa-bars" />
            </span>
          </button> */}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
